import { useSnackbar } from "notistack";
import { useState } from "react";
import { showGlobalLoadingView } from "../../../../core/utils/Utils";
import { State } from "../../../../domain/model/ResponseState";
import { ForgotPasswordUseCase } from "../../../../domain/usecase/auth/ForgotPassword/UseCase";

export function ForgotPasswordViewModel(
  forgotPasswordUseCase: ForgotPasswordUseCase
) {
  const { enqueueSnackbar } = useSnackbar();

  const [isResetPasswordEmailSent, setIsResetPasswordEmailSent] =
    useState(false);
  const [email, setEmail] = useState<string>("");

  async function sendResetPasswordEmail() {
    showGlobalLoadingView(true);
    const response = await forgotPasswordUseCase.invoke(
      email.trim().toLowerCase()
    );
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        setIsResetPasswordEmailSent(true);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return { isResetPasswordEmailSent, email, setEmail, sendResetPasswordEmail };
}
